import React, { useEffect, useRef } from 'react';
import './Services.css';

const Services = () => {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('vis');
          }
        });
      },
      { threshold: 0.1 }
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      cardsRef.current.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const services = [
    {
      icon: '🖥️',
      title: 'سرور مجازی (VPS)',
      desc: 'سرور مجازی با NVMe و هسته اختصاصی، مناسب برای پروژه‌های کوچک تا سازمانی',
      features: ['NVMe سریع', 'Root access کامل', 'کشور ایران و هلند'],
      link: '#services',
      hot: true,
    },
    {
      icon: '🏢',
      title: 'سرور اختصاصی',
      desc: 'سرور فیزیکی با قدرت پردازشی بالا برای کسب‌وکارهای بزرگ و نیازهای سنگین',
      features: ['هارد SAS/NVMe', 'پهنای باند اختصاصی', 'دیتاسنتر تهران و هلند'],
      link: '#services',
      hot: false,
    },
    {
      icon: '🌐',
      title: 'هاستینگ cPanel',
      desc: 'میزبانی وب با کنترل پنل cPanel و لایسنس رسمی',
      features: ['NVMe', 'بکاپ خودکار', 'SSL رایگان'],
      link: '#hosting',
      hot: true,
    },
    {
      icon: '📊',
      title: 'هاست DirectAdmin',
      desc: 'میزبانی وب با کنترل پنل DirectAdmin، سبک و اقتصادی',
      features: ['منبع کم‌مصرف', 'قیمت مناسب', 'پشتیبانی کامل'],
      link: '#hosting',
      hot: false,
    },
    {
      icon: '🔧',
      title: 'مدیریت سرور',
      desc: 'کانفیگ، بهینه‌سازی و امنیت سرورهای لینوکس توسط تیم حرفه‌ای',
      features: ['امنیت پیشرفته', 'بهینه‌سازی عملکرد', 'مشاوره تخصصی'],
      link: '#services',
      hot: false,
    },
    {
      icon: '📦',
      title: 'لایسنس و نرم‌افزار',
      desc: 'لایسنس رسمی cPanel، WHMCS، DirectAdmin و ماژول‌های اختصاصی',
      features: ['لایسنس اورجینال', 'نصب و راه‌اندازی', 'پشتیبانی فارسی'],
      link: '#licenses',
      hot: false,
    },
    {
      icon: '🌍',
      title: 'ثبت دامنه',
      desc: 'ثبت دامنه ملی و بین‌المللی با بهترین قیمت و انتقال رایگان',
      features: ['دامنه‌های .ir', 'دامنه‌های .com', 'انتقال رایگان'],
      link: '#domain',
      hot: false,
    },
    {
      icon: '⚡',
      title: 'اینترنت اختصاصی',
      desc: 'اینترنت P2P و TD-LTE با پهنای باند اختصاصی و پوشش گسترده در ایران',
      features: ['پهنای باند اختصاصی', 'پوشش در تهران', 'SLA تضمینی'],
      link: '#internet',
      hot: false,
      soon: true,
    },
  ];

  return (
    <section className="services" id="services">
      <div className="wrap">
        <div className="sec-header">
          <span className="sec-tag">خدمات افراسل</span>
          <h2 className="sec-h">زیرساخت کامل برای <em>هر نیازی</em></h2>
          <p className="sec-p">از هاست اشتراکی تا سرور اختصاصی — همه خدمات با کیفیت بالا و پشتیبانی فارسی</p>
        </div>
        <div className="svc-grid">
          {services.map((svc, i) => (
            <div
              key={i}
              className={`svc ${svc.hot ? 'svc-hot' : ''} ${svc.soon ? 'svc-soon' : ''}`}
              ref={el => cardsRef.current[i] = el}
            >
              {svc.hot && <span className="svc-hot-tag">پرفروش</span>}
              {svc.soon && <span className="svc-soon-tag">به‌زودی</span>}
              <span className="svc-ico">{svc.icon}</span>
              <div className="svc-h">{svc.title}</div>
              <div className="svc-d">{svc.desc}</div>
              <ul className="svc-list">
                {svc.features.map((feat, j) => (
                  <li key={j}>{feat}</li>
                ))}
              </ul>
              <button className="svc-link" onClick={() => scrollTo(svc.link.replace('#', ''))}>
                اطلاعات بیشتر ←
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
